<template>
  <div class="heightP100">
    <!-- <el-breadcrumb separator="/" class="zy-div-breadcrumb" style="z-index:10;">
      <el-breadcrumb-item> <i class="fa fa-home"></i> 首页</el-breadcrumb-item>
      <el-breadcrumb-item>日志</el-breadcrumb-item>
    </el-breadcrumb> -->
    <div class="container">
      <el-row class="queryrow">
        <div class="floatL">
          <el-date-picker
            v-model="startDate"
            type="date"
            placeholder="开始日期"
          >
          </el-date-picker>
          <el-date-picker v-model="endDate" type="date" placeholder="结束日期">
          </el-date-picker>
          <el-select v-model="exchange" placeholder="交易所">
            <el-option
              v-for="item in exchangeData"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <el-select v-model="currency" placeholder="交易对">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <el-button
            type="primary"
            class="marginL10"
            @click="getTableData"
            size="small"
            >查询</el-button
          >
        </div>
      </el-row>
      <el-row class="marginT10">
        <el-table :data="tableData" style="width: 100%" v-loading="bLoading">
          <el-table-column prop="date" label="操作员" width="180">
          </el-table-column>
          <el-table-column prop="name" label="时间" width="180">
          </el-table-column>
          <el-table-column prop="price" label="地点"> </el-table-column>
          <el-table-column prop="price" label="设备"> </el-table-column>
          <el-table-column prop="price" label="内容"> </el-table-column>
        </el-table>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currency: "",
      exchange: "",
      startDate: "",
      endDate: "",
      name: "log",
      bLoading: false,
      msg: "Welcome to Loggggggggggggggggggggggg",
      exchangeData: [
        {
          value: "KUCOIN",
          label: "KUCOIN"
        },
        {
          value: "HUOBI",
          label: "HUOBI"
        },
        {
          value: "BIAN",
          label: "BIAN"
        }
      ],
      options: [
        {
          value: "KUCOIN",
          label: "KUCOIN"
        },
        {
          value: "HUOBI",
          label: "HUOBI"
        },
        {
          value: "BIAN",
          label: "BIAN"
        }
      ],
      tableData: [
        // {
        //   date: '2016-05-02',
        //   name: '1000',
        //   price: '3000.23'
        // },
        // {
        //   date: '2016-05-04',
        //   name: '1000',
        //   price: '3000.23'
        // },
        // {
        //   date: '2016-05-01',
        //   name: '1000',
        //   price: '3000.23'
        // },
        // {
        //   date: '2016-05-03',
        //   name: '1000',
        //   price: '3000.23'
        // }
      ]
    };
  },
  computed: {
    key() {
      return this.$route.path + new Date().getTime();
    }
  },
  methods: {
    getTableData() {
      // 获取表格数据
    }
  },
  created() {}
};
</script>

<style scoped>
@import "../assets/css/log.scss";
</style>
